<li class="myre-header__menu_item" [class.bordered]="bordered">
  <div class="myre-header__menu">
    @if (withValue) {
      @if (value) {
        <span>{{ value }}</span>
      }
      @if (template) {
        <ng-container *ngTemplateOutlet="template" />
      }
    }

    <i [class]="icon"></i>

    @if (isOpen) {
      <ul
        [@appearFrom]="appearFrom"
        (@appearFrom.done)="ready = true"
        [class.responsive-adapt]="appearFrom === 'right'"
        [class.align-right]="align === 'right'"
        [class.align-left]="align === 'left'"
        class="myre-page-box sub-menu"
      >
        @if (values) {
          @for (itemValue of values; track $index; let first = $first) {
            <li>
              <myre-nav-dropdown-item
                [value]="itemValue"
                [isSelected]="itemValue === value"
                [isFirst]="first"
                (selected)="onClicked($event)"
                [class.ready]="ready"
              >
                {{ itemValue }}
              </myre-nav-dropdown-item>
            </li>
          }
        } @else {
          <ng-content />
        }
      </ul>
    }

    @if (nbNotifs > 0) {
      <span class="nb-notifs" [class.three-digits]="nbNotifs > 99">
        {{ nbNotifs < 100 ? nbNotifs : '99+' }}
      </span>
    }
  </div>
</li>
